import styled from 'styled-components';

export const ProductionAlert = styled.div`
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;

  &.in-time {
    color: ${({ theme }) => theme.colors.green};
  }

  &.possible-late {
    color: ${({ theme }) => theme.colors.orange};
  }

  &.late {
    color: ${({ theme }) => theme.colors.red};
  }

  & > span.text {
    font-size: 0.75rem;
    font-weight: 600;

    &:before {
      content: '';
      position: absolute;
      left: -2.5rem;
      top: 0.6rem;
      width: 2rem;
      border-bottom: 6px solid;
      border-radius: 5px;
    }
  }
`;
